export default "__VITE_ASSET__4czkKYnH__"